import { apiService } from './api';

export interface LoyaltyConfig {
  id?: string;
  organizationCode?: string;
  enabled: boolean;
  earnPointsPer100: number;
  redeemValuePerPoint: number;
  minRedeemPoints: number;
}

export const loyaltyService = {
  async getConfig(org: string): Promise<LoyaltyConfig> {
    const response = await apiService.get<LoyaltyConfig>('/loyalty/config', { org });
    return response.data;
  },

  async saveConfig(org: string, config: LoyaltyConfig): Promise<LoyaltyConfig> {
    const response = await apiService.put<LoyaltyConfig>(`/loyalty/config?org=${encodeURIComponent(org)}`, config);
    return response.data;
  },

  async adjustPoints(customerId: string, points: number, reason?: string): Promise<any> {
    const response = await apiService.post(`/loyalty/customers/${customerId}/adjust`, { points, reason });
    return response.data;
  },
};
